export const initialState = {
  selectedRoleGuid: "",
};

export function SELECT_ROLE(nextState, { guid }) {
  nextState.selectedRoleGuid = guid;
}
